import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import Grid from '@mui/material/Grid';
import { useT } from '@transifex/react';
import { Typography } from '@raisin/components-lib';
import { getBankOffersTableConfig } from 'utils/bankPageUtils';
import messages from '../../messages';

export interface BankOffersListHeaderProps {
  depositGuaranteeColumnWidth: { [key: string]: null | number };
  promotedProductId: string | null | undefined;
  hasNoticeOffers: boolean;
}

const BankOffersListHeader: React.FC<BankOffersListHeaderProps> = ({
  depositGuaranteeColumnWidth,
  promotedProductId,
  hasNoticeOffers = false,
}) => {
  const t = useT();
  const { locale } = useIntl();
  const isGBR = locale === 'en-GB';

  const colConfigs = useMemo(
    () => getBankOffersTableConfig(promotedProductId ?? null, locale),
    [locale, promotedProductId],
  );

  return (
    <Grid container sx={{ justifyContent: 'space-between', mb: 8 }} spacing={2}>
      <Grid item lg={colConfigs.rate.width[1]}>
        <Typography variant="subtitle1">{t(messages.bankOffersListItemRate)}</Typography>
      </Grid>
      <Grid item lg={colConfigs.duration.width[1]}>
        <Typography variant="subtitle1">
          {hasNoticeOffers
            ? t(messages.bankOffersListItemDurationAndNoticePeriod)
            : t(messages.bankOffersListItemDuration)}
        </Typography>
      </Grid>
      {isGBR ? (
        <Grid
          item
          lg={
            depositGuaranteeColumnWidth?.lg
              ? depositGuaranteeColumnWidth.lg
              : colConfigs.depositGuarantee.width[1]
          }
        >
          <Typography variant="subtitle1">
            {t(messages.bankOffersListItemDepositGuarantee)}
          </Typography>
        </Grid>
      ) : (
        <Grid item lg={colConfigs.depositGuarantee.width[1]}>
          <Typography variant="subtitle1">{t(messages.bankOffersListItemCurrency)}</Typography>
        </Grid>
      )}
      <Grid item lg={colConfigs.product.width[1]}>
        <Typography variant="subtitle1">{t(messages.bankOffersListItemProductType)}</Typography>
      </Grid>

      <Grid
        item
        lg={colConfigs.orderBtn.width[1]}
        sx={{ display: 'flex', justifyContent: 'flex-end' }}
      ></Grid>
    </Grid>
  );
};

export default BankOffersListHeader;
